import React from 'react'
import { connect } from 'react-redux'

const SwitchLocale = ({ country, onClick }) => (
  <div className='Switch_locale'>
    {country && (
      <label
        onClick={onClick}
        className='Switch_locale__label Switch_locale__label_bold'
      >
        {country.title}
      </label>
    )}
  </div>
)

export default connect(state => {
  const currentCountry = window.localStorage.getItem('countryId') || null
  return {
    country: currentCountry && state.countries[currentCountry]
  }
})(SwitchLocale)



// WEBPACK FOOTER //
// ./src/components/Locale/SwitchLocale.jsx